import ProfesionalesList from './ProfesionalesList';
import ProfesionalesShow from './ProfesionalesShow';

const profesionales = {
    list: ProfesionalesList,
    show: ProfesionalesShow,
};

export default profesionales;
